import { render, staticRenderFns } from "./TransferCompanyRequests.vue?vue&type=template&id=4155ff31&scoped=true"
import script from "./TransferCompanyRequests.vue?vue&type=script&lang=js"
export * from "./TransferCompanyRequests.vue?vue&type=script&lang=js"
import style0 from "./TransferCompanyRequests.vue?vue&type=style&index=0&id=4155ff31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155ff31",
  null
  
)

export default component.exports